import React, { useEffect, useState } from "react";

// Цвета читаются через CSS-переменные --med-* с дефолтами (исходная
// расцветка) -- страница-потребитель может переопределить --med-* в своей
// scoped-теме (см. .rozetka-mapping-page в RozetkaMappingPage.css), без
// переопределения тема не меняется.
const wrap = { display: "grid", gap: "6px" };
const input = {
    width: "100%", padding: "9px", boxSizing: "border-box", borderRadius: "6px",
    border: "1px solid var(--med-border, #cbd5e1)", background: "var(--med-field, #fff)", color: "var(--med-text, #0f172a)",
};
const list = {
    overflow: "auto", borderRadius: "8px", display: "grid", gap: "4px", padding: "6px",
    border: "1px solid var(--med-border, #e2e8f0)", background: "var(--med-surface, transparent)",
};
const item = {
    padding: "8px 10px", borderRadius: "6px", cursor: "pointer", textAlign: "left",
    border: "1px solid var(--med-border, #e2e8f0)", background: "var(--med-surface, #fff)", color: "var(--med-text, #0f172a)",
};
const itemActive = { ...item, background: "var(--med-accent-soft, #dbeafe)", borderColor: "var(--med-accent, #2563eb)" };
const empty = { padding: "8px", color: "var(--med-muted, #64748b)" };
const errorText = { color: "var(--med-danger, #b91c1c)", fontSize: "12px" };

// Общий поиск-с-debounce для маппинг-страниц маркетплейсов (см.
// docs/rozetka_stage1_catalog_stock_plan.md §2.2/§6.1) -- заменяет 3 почти
// идентичные копии этой логики, которые Prom переизобретает внутри самого
// себя (PromMappingsPage/PromAttributesPage/IntegrationsPage).
//
// `fetchFn` должен быть стабильной ссылкой (обернуть в useCallback на
// стороне вызывающего), иначе debounce будет сбрасываться на каждый рендер
// родителя.
const SearchableEntityDropdown = ({
    label,
    placeholder = "",
    fetchFn,
    getKey,
    renderLabel,
    selectedKey,
    onPick,
    debounceMs = 180,
    resultsHeight = "220px",
    initialQuery = "",
}) => {
    const [query, setQuery] = useState(initialQuery);
    const [results, setResults] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        let cancelled = false;
        const timer = setTimeout(async () => {
            try {
                const rows = await fetchFn(query);
                if (!cancelled) {
                    setResults(rows || []);
                    setError("");
                }
            } catch (err) {
                if (!cancelled) setError(err?.response?.data?.detail || "Не удалось выполнить поиск.");
            }
        }, debounceMs);
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [query, fetchFn, debounceMs]);

    return (
        <div style={wrap}>
            {label && <span style={{ fontWeight: 700 }}>{label}</span>}
            <input style={input} placeholder={placeholder} value={query} onChange={(event) => setQuery(event.target.value)} />
            <div style={{ ...list, maxHeight: resultsHeight }}>
                {results.map((row) => {
                    const key = getKey(row);
                    return (
                        <button
                            key={key}
                            type="button"
                            style={String(key) === String(selectedKey) ? itemActive : item}
                            onClick={() => onPick(row)}
                        >
                            {renderLabel(row)}
                        </button>
                    );
                })}
                {!results.length && <span style={empty}>Ничего не найдено.</span>}
            </div>
            {error && <span style={errorText}>{error}</span>}
        </div>
    );
};

export default SearchableEntityDropdown;
